<template>
    <modal @close="$emit('close')">
        <p class="text-white font-bold text-xl top-font -mt-6" slot="header">Мест нет</p>
        <div class="py-8  text-main-text">
            <div class="flex flex-col text-center w-full justify-center items-center">

                <div class="px-6">
                    <img class="-mt-6 flex w-2/5 mb-6 mx-auto" src="@/assets/SVG/big-cross.svg"
                        alt="check-circle">
                    <h3 class="flex flex-col text-center w-full justify-center items-center text-2xl font-extrabold">
                        Извините, места в резервном списке закончились</h3>
                    <div
                        class="text-sm flex flex-col text-center w-full justify-center items-center pt-4">
                        <p>Попробуйте записаться на другой день. Ждём вас!</p>
                    </div>

                    <button @click="$emit('close')"
                        class="mt-4 bg-brand-light rounded-full text-white text-sm font-semibold w-full h-10">
                        Расписание
                    </button>
                </div>
            </div>

        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'SuccessOrFail',
  components: { Modal },
  props: ['success_or_fail', 'success'],
  mixins: [ModalMixin],
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
    };
  },

};

</script>

<style scoped>

</style>
